export default {
      id: "big-vita-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#big-vita",
      toString: function () {
        return this.url;
      }
    }